import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69cb480c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = {
  key: 1,
  class: "container_content"
}
const _hoisted_4 = {
  class: "content_address",
  id: "warrants"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "frame_form" }
const _hoisted_7 = {
  class: "form_one",
  id: "warrants"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_title font_size" }, "账号：", -1))
const _hoisted_9 = { class: "form_load" }
const _hoisted_10 = {
  class: "form_two",
  id: "warrants"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_title font_size" }, "密码：", -1))
const _hoisted_12 = { class: "form_load" }
const _hoisted_13 = { class: "frame_select" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select_head" }, "权限：", -1))
const _hoisted_15 = { class: "select_tab" }
const _hoisted_16 = ["data-clipboard-text"]
const _hoisted_17 = { class: "content_upload" }
const _hoisted_18 = { class: "content_btn" }
const _hoisted_19 = { class: "add_message" }
const _hoisted_20 = { class: "add_message_box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add_title font_size" }, "账号：", -1))
const _hoisted_22 = { class: "add_load" }
const _hoisted_23 = { class: "add_message_box" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add_title font_size" }, "密码：", -1))
const _hoisted_25 = { class: "add_load" }
const _hoisted_26 = { class: "add_message_boxs" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add_head font_size" }, "权限：", -1))
const _hoisted_28 = { class: "add_select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Crumb = _resolveComponent("Crumb")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_c_loading = _resolveComponent("c-loading")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_c_del_modal = _resolveComponent("c-del-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 直播助手 "),
        _createVNode(_component_a_switch, {
          class: "btns_txt",
          checkedValue: 1,
          unCheckedValue: 0,
          checked: _ctx.obj.status,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.obj.status) = $event)),
          onChange: _ctx.DownClose
        }, null, 8, ["checked", "onChange"])
      ]),
      (_ctx.showLoading)
        ? (_openBlock(), _createBlock(_component_c_loading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, "登陆地址:  " + _toDisplayString(_ctx.obj.login_url), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "content_frame",
                key: index
              }, [
                _createElementVNode("div", {
                  class: "frame_icon",
                  onClick: ($event: any) => (_ctx.closeClick(item.id))
                }, [
                  _createVNode(_component_CloseOutlined)
                ], 8, _hoisted_5),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_a_input, {
                        value: item.account,
                        "onUpdate:value": ($event: any) => ((item.account) = $event),
                        class: "font_size"
                      }, null, 8, ["value", "onUpdate:value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: item.password,
                            "onUpdate:value": ($event: any) => ((item.password) = $event),
                            type: "password",
                            placeholder: "密码不能少于6位数",
                            class: "font_size"
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: item.chat,
                              "onUpdate:checked": ($event: any) => ((item.chat) = $event),
                              class: "font_size"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("聊天互动")
                              ]),
                              _: 2
                            }, 1032, ["checked", "onUpdate:checked"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: item.set,
                              "onUpdate:checked": ($event: any) => ((item.set) = $event),
                              class: "font_size"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("直播设置")
                              ]),
                              _: 2
                            }, 1032, ["checked", "onUpdate:checked"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: item.control,
                              "onUpdate:checked": ($event: any) => ((item.control) = $event),
                              class: "font_size"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("直播控制")
                              ]),
                              _: 2
                            }, 1032, ["checked", "onUpdate:checked"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: item.data,
                              "onUpdate:checked": ($event: any) => ((item.data) = $event),
                              class: "font_size"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("数据中心")
                              ]),
                              _: 2
                            }, 1032, ["checked", "onUpdate:checked"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", {
                    class: "select_clone warrent",
                    "data-clipboard-text": 
              '活动名称：' +
              _ctx.liveData.title +
              '\n' +
              '观看链接：' +
              _ctx.liveData.qr_code_url +
              '\n' +
              '管理链接：' +
              _ctx.obj.login_url +
              '\n' +
              '登录账号：' +
              item.reqAccount +
              '\n' +
              '登录密码：' +
              item.reqPassword
            ,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Copylist('.select_clone')))
                  }, [
                    _createVNode(_component_a_button, { class: "text_clone" }, {
                      default: _withCtx(() => [
                        _createTextVNode("一键复制")
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_16)
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_a_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal()))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_PlusOutlined)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_a_button, {
                onClick: _ctx.DownClose,
                class: "btns",
                type: "primary",
                disabled: _ctx.disabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ]))
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.confirm,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.confirm) = $event)),
      title: "添加直播助手",
      centered: "",
      onOk: _ctx.keep,
      okText: "保存",
      closable: "",
      class: "avatar_uploader_modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_a_input, {
                value: _ctx.prompt.realm,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.prompt.realm) = $event)),
                class: "font_size",
                placeholder: "请输入账号"
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.prompt.passwords,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prompt.passwords) = $event)),
                    class: "font_size",
                    placeholder: "密码不能少于6位数",
                    type: "password"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_a_checkbox, {
                checked: _ctx.prompt.checks,
                "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.prompt.checks) = $event)),
                class: "font_size"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("聊天互动")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_component_a_checkbox, {
                checked: _ctx.prompt.direct,
                "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.prompt.direct) = $event)),
                class: "font_size"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("直播设置")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_component_a_checkbox, {
                checked: _ctx.prompt.lived,
                "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.prompt.lived) = $event)),
                class: "font_size"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("直播控制")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_component_a_checkbox, {
                checked: _ctx.prompt.Data,
                "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.prompt.Data) = $event)),
                class: "font_size"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("数据中心")
                ]),
                _: 1
              }, 8, ["checked"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_c_del_modal, {
      visible: _ctx.deletes,
      centered: "",
      close: _ctx.openDelModal,
      ok: _ctx.close
    }, null, 8, ["visible", "close", "ok"])
  ], 64))
}